<script>
import baseMixin from '@/mixins/baseMixin'
import DataPoint from '@/models/general/dataPoint'

export default {
  name: 'StatisticsBreakdownSummaryDataPoint',
  mixins: [baseMixin],
  props: {
    dataPoint: {
      type: DataPoint,
      required: true,
    },
    filter: {
      type: Boolean,
    },
  },
}
</script>

<template>
  <div>
    <data
      data-testid="statistics-breakdown-summary-data-point-value"
      class="text-h6 font-weight-bold"
      :value="dataPoint.value"
      >{{ dataPoint.value }}</data
    >
    <p
      data-testid="statistics-breakdown-summary-data-point-title"
      class="text-caption mb-0"
      ><v-badge :value="filter" :color="dataPoint.color" inline dot tile
        ><span class="pr-2">{{ dataPoint.title }}</span></v-badge
      ></p
    >
  </div>
</template>
